import { ConfigProvider } from 'antd';

const AntdThemeProvider = ({ children }) => {
	const defaultComponentSize = 'middle';

	const customTheme = {
		components: {
			Input: {
				inputFontSize: 14,
			},
			InputNumber: {
				inputFontSize: 14,
			},
			Form: {
				labelFontSize: '14px',
				// labelColor: '#555',
				labelColor: '#000000e0',
				verticalLabelPadding: '0 0 4px 0',
			},
			Select: {
				fontSize: 14,
				optionFontSize: 14,
			},
			Calender: {
				fontSize: 14,
				calendarFontSize: 14,
			},
			DatePicker: {
				inputFontSize: 14,
			},
			Tree: {
				directoryNodeSelectedBg: '#e2ebf7',
				directoryNodeSelectedColor: '#000000',
			},
		},
		token: {
			colorBgContainerDisabled: 'rgba(112, 112, 112, 0.04)',
			borderRadius: 8,
			// controlHeight: 44,
			controlHeight: 38,
			// borderRadiusLG: 8,
			// controlHeightLG: 44,
			colorBorder: '#ccc',
			fontFamily: "'Inter', sans-serif",
			fontSizeLG: 16,
			colorTextDisabled: '#615353',
		},
	};

	return (
		<ConfigProvider theme={customTheme} componentSize={defaultComponentSize}>
			{children}
		</ConfigProvider>
	);
};

export default AntdThemeProvider;
